/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Top_Center_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Top Center" |
*
* @param {Position_Top_Center_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_top_center_title = /** @type {((inputs?: Position_Top_Center_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Top_Center_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : En Haut au Centre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Oben Mitte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: Centro in alto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Верхний центр")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Centro superior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：顶部中心")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置: 上部中央")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थान: शीर्ष केंद्र")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Centro Superior")
	return /** @type {LocalizedString} */ ("Position: Top Center")
});